import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonDialogsModule } from 'idk/widgets/common-dialogs/common-dialogs.module';
import { MenuBuilderModule } from 'idk/menu-builder/menu-builder.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { providePrimeNG } from 'primeng/config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { SipcoPreset } from 'app/core/config/primeng-theme';
import { provideCodeEditor } from '@ngstack/code-editor';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    // onSameUrlNavigation: 'reload', // NO Habilitar, esto hace que procesos como el login queden ciclados infinitamente
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        // FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        MatDialogModule,

        CommonDialogsModule,

        MenuBuilderModule,

        MatNativeDateModule,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: SipcoPreset,
                options: {
                    darkModeSelector: 'is-dark',
                },
            },
        }),
        provideCodeEditor({
            baseUrl: 'assets/monaco',
        })
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

